import CardProductVertical from "./card-product-vertical";

export default CardProductVertical;